// extracted by mini-css-extract-plugin
export default {"item":"ZyxdbIagVo2SOiHaIZWZ","multiLineText":"ZaHF_L7hws3SxqWFcN5j","dimensions":"jTDFZISJS9TkdmxURNap","margin":"XF8DdcvZJ1CMJcAhpSbs"};